module.exports = __webpack_public_path__ + "static/media/ic-crm-file-management.df154d5f.svg";